module.exports = __webpack_public_path__ + "static/media/information_technology.dbe8eb52.png";